<template>
  <div class="scaling-svg-container" :style="{ paddingBottom: pb}">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'SvgContainer',
  mounted () {
    var selector = this.$slots.default[0].child.$el
    this.svg = selector
  },
  data () {
    return {
      svg: null
    }
  },
  computed: {
    box () {
      if (this.svg != null) {
        return this.svg.viewBox.baseVal
      } else {
        return null
      }
    },
    pb () {
      if (this.box != null) {
        return ((this.box.height / this.box.width) * 100).toFixed(2) + '%'
      } else {
        return '100%'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.scaling-svg-container {
  position: relative;
  height: 0;
  width: 100%;
  padding: 0;
  padding-bottom: 100%;
   /* override this inline for aspect ratio other than square */
}
.scaling-svg {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
 }
</style>



// WEBPACK FOOTER //
// src/components/SvgContainer.vue